import React from 'react';
import { Radar } from 'react-chartjs-2';
import { Chart as ChartJS, RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend } from 'chart.js';
import useWindowSize from '../../utils/useWindowSize'; // 1. Importamos el hook

ChartJS.register(RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend);

function SkillsRadarChart({ skillScores = [], customAccentColor, customTextColor }) {
    const { width } = useWindowSize(); // 2. Obtenemos el ancho de la pantalla
    const isMobile = width < 768;

    const textColor = customTextColor || getComputedStyle(document.documentElement).getPropertyValue('--text-secondary').trim();
    const accentColor = customAccentColor || getComputedStyle(document.documentElement).getPropertyValue('--accent').trim();

    const data = {
        labels: skillScores.map(s => s.skill_name),
        datasets: [{
            label: 'Ejercicios Completados',
            data: skillScores.map(s => s.score),
            backgroundColor: accentColor + '4D',
            borderColor: accentColor,
            borderWidth: 2,
            pointBackgroundColor: accentColor,
            pointBorderColor: '#000000',
            pointHoverBackgroundColor: '#ffff00',
            pointHoverBorderColor: '#000000',
            pointRadius: isMobile ? 3 : 4,
        }]
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            r: {
                angleLines: { color: 'var(--border-color)' },
                grid: { color: 'var(--border-color)' },
                // 3. Hacemos la fuente de las etiquetas más pequeña en móvil
                pointLabels: { color: textColor, font: { size: isMobile ? 10 : 12 } },
                ticks: {
                    display: false, // Ocultamos los números del eje para un look más limpio
                }
            }
        },
        plugins: {
            legend: { display: false }
        }
    };

    return <Radar data={data} options={options} />;
}

export default SkillsRadarChart;